/**
 * 设计令牌常量
 * 颜色值、间距、圆角等，供 MUI sx prop 和 Tailwind 共享
 * 避免在组件中硬编码色值
 */

export const COLORS = {
  // 主色调 - 品牌红
  primary: '#E53935',
  primaryLight: '#EF5350',
  primaryDark: '#C62828',
  primaryBg: '#FFEBEE',

  // 辅助色 - 蓝
  secondary: '#1976D2',
  secondaryLight: '#42A5F5',
  secondaryDark: '#1565C0',

  // 语义色
  success: '#4CAF50',
  successBg: '#E8F5E9',
  warning: '#FF9800',
  warningBg: '#FFF3E0',
  info: '#2196F3',
  infoBg: '#E3F2FD',
  error: '#E53935',
  errorBg: '#FFEBEE',
  purple: '#9C27B0',
  purpleBg: '#F3E5F5',

  // 中性色
  textPrimary: '#333333',
  textSecondary: '#666666',
  textDisabled: '#999999',
  border: '#E0E0E0',
  backgroundDefault: '#F5F5F5',
  backgroundPaper: '#FFFFFF',
  tableHeader: '#FAFAFA',
  tableHover: '#F5F5F5',
  tableDivider: '#F0F0F0',

  // 特殊色
  gold: '#FFD700',
  starInactive: '#E0E0E0',

  // 渐变背景
  welcomeGradient: 'linear-gradient(135deg, #E3F2FD, #BBDEFB)',
  appIconGradient: 'linear-gradient(135deg, #E53935, #EF5350)',

  // 市场活动渐变
  activityGradients: {
    indigo: 'linear-gradient(135deg, #5C6BC0, #3F51B5)',
    pink: 'linear-gradient(135deg, #EC407A, #E91E63)',
    cyan: 'linear-gradient(135deg, #26C6DA, #00BCD4)',
    green: 'linear-gradient(135deg, #66BB6A, #4CAF50)',
  },
} as const;

export const SPACING = {
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 20,
  xxl: 24,
  xxxl: 32,
} as const;

export const BORDER_RADIUS = {
  small: 4,
  medium: 8,
  large: 12,
  pill: 16,
} as const;

export const SHADOWS = {
  card: '0 2px 8px rgba(0, 0, 0, 0.08)',
  cardHover: '0 4px 12px rgba(0, 0, 0, 0.12)',
} as const;

export const LAYOUT = {
  topNavHeight: 64,
  maxContentWidth: 1440,
  sidebarWidth: 240,
  contentPadding: 24,
} as const;

